// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import { QbCustomerFullDto } from './QbCustomerFullDto';

// AbilityIntranet.Data.Intranet.QbModels.QbCustomerEditDto
export class QbCustomerEditDto extends QbCustomerFullDto {
    public newNote: string = null;
    public dataExtensionsDict: { [key: string]: string; } = {};
}


    



